<template>
  <Modal :title="title" :showModal="showModal" :config="modalConfig" class="edit-line-item-form edit-line-item large" @cancel="cancel" @submit="submit">
    <template v-slot:body>
      <div class="popup-wrap left-box">
        <div class="edit-order-container row">
          <div class="position-relative form-group print-methods col-12">
            <label class="col-12 mb-0 p-0 font-weight-bold">Printer Methods</label>
            <div class="btn-group-sm nav btn-group mt-2 d-inline-block">
              <div v-for="(object, index) in more.print_methods" :key="index" class="radio-container btn-shadow btn show p-0 mb-1">
                <input type="radio" name="print_method" :value="object.id" :checked="data.print_method == object.id" @change="store.commit('print_method', object.id)" />
                <span href="#" class="checkmark p-2" style="min-width: 50px">{{ object.text }}</span>
              </div>
            </div>
          </div>

          <div class="position-relative form-group color-batches col-12">
            <label class="col-12 mb-2 p-0">Color Batches</label>
            <Select :options="more.color_batches" placeholder="Color Batches" data-title="Color Batches" class="has-tip" :value="data.color_batch" @changeValue="store.commit('color_batch', $event)"></Select>
          </div>

          <div class="position-relative form-group attributes col-12">
            <label class="col-12 mb-2 p-0">Attributes</label>
            <div v-for="(attribute, index) in data.attributes" :key="index" class="position-relative form-group">
              <label class="col-12 mb-0 p-0 text-capitalize">{{ listAttributes[index] ? listAttributes[index].label : index }}*</label>
              <div class="input-group mt-2">
                <input class="form-control" type="text" name="attributes[]" :readonly="!editable" :value="attribute" @change="handleChangeAttribute(index, $event)" />
                <div v-if="editable" class="input-group-append">
                  <a href="#remove" class="btn btn-light text-danger remove input-group-text" @click.prevent="handleRemoveAttribute(index)">Remove</a>
                </div>
              </div>
            </div>
            <div v-for="(object, index) in newAttributes" :key="index" class="position-relative form-group">
              <label class="col-12 mb-0 p-0">
                <input class="form-control" type="text" name="attributes[]" :readonly="!editable" placeholder="Attributes Name" v-model="object.name" />
              </label>
              <div class="input-group mt-2">
                <input class="form-control" type="text" name="attributes[]" :readonly="!editable" placeholder="Attributes Value" v-model="object.value" />
                <div v-if="editable" class="input-group-append">
                  <a href="#remove" class="btn btn-light text-danger remove input-group-text" @click="newAttributes.splice(index, 1)">Remove</a>
                </div>
              </div>
            </div>
            <a href="#add-more" v-if="editable" class="btn btn-outline-primary add-more" @click="newAttributes.push({})">Add More</a>
          </div>
          <div class="position-relative form-group note col-12">
            <label class="col-12 mb-0 p-0">Note*</label>
            <div v-for="(note, index) in data.note" :key="index" class="input-group mt-2">
              <textarea class="form-control" type="text" name="note[]" :readonly="!editable" :value="note" @change="store.commit(['note', index], $event.currentTarget.value)"></textarea>
              <div v-if="editable" class="input-group-append">
                <a href="#remove" class="btn btn-light text-danger remove input-group-text" @click="handleRemoveNote(index)">Remove</a>
              </div>
            </div>
            <a href="#add-more" v-if="editable" class="btn btn-outline-primary mt-3 add-more" @click="store.commit(['note', data.note.length], '')">Add More</a>
          </div>

          <div class="position-relative form-group col-12">
            <label class="col-12 mb-2 p-0">Sku</label>
            <input class="form-control" type="text" :value="data?.sale_detail?.more?.sku" @change.stop.prevent="store.commit('sale_detail.more.sku', $event.target.value)" />
          </div>
          <div v-if="!isSubOrder" class="position-relative form-group col-12">
            <label class="col-12 mb-2 p-0">Status</label>
            <Select :options="statusOptions" placeholder="Status" data-title="Status" class="has-tip" :value="data.status" @changeValue="store.commit('status', $event)"></Select>
          </div>
        </div>
      </div>

      <div class="choose-line-item line-items">
        <div class="search-form d-flex">
          <input type="text" class="form-control flex-1" name="filters[q]" placeholder="Design name" v-model="searchSuggestDesign" />
          <div @click.prevent="handleSearchSuggestDesign" class="btn btn-outline-success ml-2">Search</div>
        </div>
        <div class="check-container new-design" @click="store.commit('design_id', 'new')">
          <input type="radio" :disabled="!editable" name="design_id" value="new" :checked="data.design_id == 'new'" />
          <span class="design-title checkmark col-12">
            <div>
              <span>Create new line item design</span>
              <ul class="flags">
                <li v-for="(object, index) in data.more.flags" :key="index" class="radio-container">
                  <input type="radio" name="design[flag]" :checked="designFlag == index" :value="index" @change="handleChangeFlag(index)" />
                  <span :class="`checkmark choose-flag ${index}`"></span>
                </li>
              </ul>
            </div>
            <p>
              <input :disabled="!editable" type="text" name="design_name" class="form-control" placeholder="Design name" v-model="suggestDesignName" @click="store.commit('design_id', 'new')" />
            </p>
          </span>
        </div>
        <ul class="list-design" ref="listDesign">
          <li v-for="(design, index) in data.designs.data" :key="index" :class="`line-item-design-wrap line-item-design-${design.id} check-container`">
            <input type="radio" :disabled="!editable" name="design_id" :value="design.id" :checked="data.design_id == design.id" @click="store.commit('design_id', design.id)" />
            <div class="line-item-design checkmark d-flex">
              <div class="line-item-thumbnail">
                <Image :src="$util.addQueryParam(design?.thumbnail, { size: 'xs' })" />
              </div>
              <div class="d-flex flex-wrap pt-3 pb-3" style="flex: 1">
                <div class="form-group col-12">
                  <label class="mb-0 p-0">Title:</label>
                  <span class="select-all">{{ design.name }}</span>
                </div>
                <div :class="`col-12 form-group pr-0 design-status flag ${design.status} ${design.flag}`">
                  <span class="m-0">{{ listDesignStatus[design.status] ? listDesignStatus[design.status].label : design.status }}</span>
                </div>

                <div v-show="design.manual" class="col-12 form-group pr-0">
                  <span class="manual ml-0">Manual</span>
                </div>

                <div v-for="(values, index) in design.attributes" :key="index" class="form-group col-12">
                  <label class="mb-0 p-0 text-capitalize">{{ listAttributes[index] ? listAttributes[index].label : index }}:</label>
                  <div>
                    <span class="select-all">{{ $_.isObjectLike(values) ? Object.values(values).join(', ') : values }}</span>
                  </div>
                </div>
                <div v-show="design.note" class="col-12 d-flex flex-wrap">
                  <label class="col-12 mb-0 p-0">Note:</label>
                  <p v-for="(value, index) in design.note" :key="index" class="form-group col-6">
                    {{ value }}
                  </p>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <PageNav :display="{ total: false }" :config="query" @changeValue="changePage" class="d-flex mt-2 col-12 justify-content-center float-none pagination-wrapper"></PageNav>
      </div>
    </template>
  </Modal>
</template>

<script>
import Event from '@/helper/event.js'
import PageNav from '@/components/PageNav.vue'
export default {
  mixins: [Event],
  components: {
    PageNav
  },
  data() {
    /* prettier-ignore */
    return {
      newAttributes: [],
      suggestDesignName: '',
      searchSuggestDesign: '',
      designFlag: '',
      query: {},
      submitStructure: [
        'sale_detail.more.sku',
        'attributes',
        'note',
        'design_flag',
        'new_design_name',
        'design_id',
        'print_method',
        'color_batch',
        'status'
      ]
    }
  },
  created() {
    this.store.commit('', {})
  },
  computed: {
    title() {
      return 'Edit Line Item'
    },
    action() {
      return 'edit-line-item'
    },
    storeId() {
      return this.config?.storeId
    },
    lineItemIdentify() {
      return this.config?.data?.identify
    },
    getUri() {
      return `line-item/get/${this.lineItemIdentify}`
    },
    submitUri() {
      return `line-item/update/${this.lineItemIdentify}`
    },
    data() {
      return this.store.getter('', {
        more: {},
        designs: {}
      })
    },
    more() {
      return this.data.more || {}
    },
    modalConfig() {
      return {}
    },
    isSubOrder() {
      return false
    },
    editable() {
      return this.data.permission == 'edit' || this.isSubOrder
    },
    listAttributes() {
      return this.data.more.attributes || {}
    },
    listDesignStatus() {
      return this.data.more.design_status || {}
    },
    suggestDesignFields() {
      return this.data.more.suggest_design_fields || {}
    },
    statusOptions() {
      return Object.values(
        this.$util.map(this.data.more.status || {}, ({ item, key }) => {
          return {
            id: key,
            text: item.label
          }
        })
      )
    }
  },
  methods: {
    setUpData(rawData) {
      this.showModal = true
      if (!_.isPlainObject(rawData.data.attributes)) {
        rawData.data.attributes = {}
      }
      Object.entries(rawData.data.more.attributes).forEach(([key]) => {
        if (!rawData.data?.attributes?.[key]) {
          rawData.data.attributes[key] = null
        }
      })
      this.store.commit('', rawData.data)
      this.handleSuggestDesignName()
      this.queryChange({
        suggest: this.suggestDesignName
      })
    },
    handleChangeFlag(index) {
      this.designFlag = index
      this.handleSuggestDesignName()
    },
    handleChangeAttribute(index, e) {
      this.store.commit(['attributes', index], e.currentTarget.value)
      this.handleSuggestDesignName()
    },
    handleRemoveAttribute(index) {
      let attributes = this.store.getter('attributes', {})
      if (attributes[index] !== undefined) {
        delete attributes[index]
      }
      this.store.commit('attributes', attributes)
    },
    handleSearchSuggestDesign() {
      this.queryChange({
        search: this.searchSuggestDesign
      })
    },
    handleSuggestDesignName() {
      try {
        this.suggestDesignName = this.data.more.suggest_design_name[this.designFlag && this.designFlag != 'empty' ? 'has_flag' : 'no_flag'] || ''
      } catch {
        this.suggestDesignName = ''
      }

      let items = Object.assign(
        {},
        this.data.attributes,
        {
          index: this.config?.data.index
        },
        this.suggestDesignFields
      )
      Object.entries(items).forEach(([key, val]) => {
        this.suggestDesignName = this.suggestDesignName.replaceAll(new RegExp('{{%\\s*' + key + '\\s*%}}', 'g'), val || '')
      })

      this.suggestDesignName = this.suggestDesignName.replaceAll(new RegExp('^(\\s*-)+\\s*|{{%\\s*[\\w|\\d|_|-]+\\s*%}}|\\s*(-\\s*)+$', 'g'), '').replaceAll(new RegExp('(\\s*-)+\\s*(-\\s*)+', 'g'), ' - ')
    },
    handleRemoveNote(index) {
      let note = this.store.getter('note', [])
      note.splice(index, 1)
      if (note.length == 0) {
        note.push('')
      }
      this.store.commit('note', note)
    },
    changePage(value) {
      this.query.page = value
      this.queryChange()
    },
    queryChange(filter) {
      filter = Object.assign({}, filter, this.query)
      this.$util.get(`line-item/suggest-design/${this.lineItemIdentify}`, filter, this.$refs.listDesign, {
        done: (response) => {
          if (response.status == 'success') {
            this.store.commit('designs.data', response.data)
            this.query = response.pagination
          }
        }
      })
    },
    cancel() {
      //
    },
    submit() {
      let newAttributes = Object.assign({}, this.data.attributes)
      this.newAttributes.forEach((object) => {
        newAttributes[object.name] = object.value
      })
      let data = Object.assign({}, this.data, {
        design_flag: this.designFlag,
        new_design_name: this.suggestDesignName,
        attributes: newAttributes
      })
      this.submitForm(data, {
        done: () => {
          this.$emit('close')
          this.$emitter.emit('TableList.Refresh')
        }
      })
    }
  },
  props: {
    config: Object
  }
}
</script>
<style lang="scss">
.edit-line-item-form {
  .modal-body .body-container {
    display: flex;
  }
  .choose-line-item {
    .search-form .btn {
      width: auto;
      height: auto;
      margin: 0;
    }
  }
  .radio-container,
  .checkbox-container {
    background-color: #deffde;
    color: #1a881d;
    input {
      &:checked ~ .checkmark {
        background-color: #26be2b;
        color: #fff;
      }
    }
  }
}
</style>
